import { base64 } from "rfc4648";

const deriveKey = async (password: string) => {
  const encoder = new TextEncoder();

  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    encoder.encode(password),
    "PBKDF2",
    false,
    ["deriveBits", "deriveKey"]
  );

  const salt = encoder.encode("TODOSALT"); // TODO(Marko): SALT

  const key = await crypto.subtle.deriveKey(
    {
      "name": "PBKDF2",
      salt: salt,
      "iterations": 100000,
      "hash": "SHA-256"
    },
    keyMaterial,
    {
      "name": "AES-GCM",
      "length": 256
    },
    true,
    ["encrypt", "decrypt"]
  );

  return key;
}

export const encrypt = async (
  text: string,
  password: string
) => {
  const encoder = new TextEncoder();

  const key = await deriveKey(password);
  const iv = encoder.encode("TODO(IV)"); // TODO(Marko): IV
  const encodedText = encoder.encode(text);

  const encodedEncryptedText = await crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv,
    },
    key,
    encodedText
  );

  return base64.stringify(new Uint8Array(encodedEncryptedText));
}

export const decrypt = async (
  encryptedText: string,
  password: string
) => {
  const encoder = new TextEncoder();
  const decoder = new TextDecoder();

  const key = await deriveKey(password);
  const iv = encoder.encode("TODO(IV)"); // TODO(Marko): IV

  const encodedEncryptedText = base64.parse(encryptedText);

  return new Promise((
    resolve, reject
  ) => crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv,
    },
    key,
    encodedEncryptedText
  ).then(
    (encodedText: any) => {
      resolve(decoder.decode(encodedText));
    },
    (error: any) => {
      reject(error);
    }
  ));
}
